import React, { useState } from "react";

import { Button, Col, Form, InputNumber, Row, Select, Table } from "antd";

import FilterContainer from "../../../../components/common/FilterContainer";
import MultiSelect from "../../../../components/common/MultiSelect";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import TreeMultiSelect from "../../../../components/common/TreeSelect";

import { glAccounts, payees, recurringBills } from "../../../../data/accounting";
import { Propertiesunitscampaigns } from "../../../../data/renewals";

import { FaDollarSign } from "react-icons/fa";

import "./RecurringInvoices.css";
import { useNavigate } from "react-router-dom";

const PayablesRecInvoicesRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Enter Bill", "1", "", "", "/accounting/payables_bills/bills/enter-bils"),
    RightBarMethod("Automated AP", "2", "", "", ""),
    RightBarMethod("Smart Bill Entry", "3", "", "", "/accounting/payables_bills/bills/smartbillentry"),
    RightBarMethod("Enter Utility Bill (RUBS)", "5", "", "", "/accounting/payables_bills/bills/utility-bill-details"),
    RightBarMethod("Enter Credit", "6", "", "", ""),
    RightBarMethod("Pay Bills", "7", "", "", "/accounting/payables_bills/paybills"),
    RightBarMethod("Tenant Payable", "8", "", "", "/accounting/payables_bills/bills/newtenantpayable"),
    RightBarMethod("New Recurring Bill", "9", "", "", "/accounting/payables_bills/recurring_invoices/newrecurringbill"),
    RightBarMethod("Manually Post Bills", "10", "", "", "/accounting/payables_bills/recurring_invoices/manually_post_bills"),
    RightBarMethod("Upload Bulk Bills", "11", "", "", "/accounting/payables_bills/bills/upload-bulk-bills"),
  ]),
];

function RecurringInvoices() {
  const [sortedInfo, setSortedInfo] = useState({});

  const navigate = useNavigate();

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const columns = [
    {
      title: "Payee",
      dataIndex: "payee",
      key: "payee",
      sorter: (a, b) => a.payee.length - b.payee.length,
      sortOrder: sortedInfo.columnKey === "payee" ? sortedInfo.order : null,
    },
    {
      title: "GL Account",
      dataIndex: "glAccount",
      key: "glAccount",
      sorter: (a, b) => a.glAccount.length - b.glAccount.length,
      sortOrder: sortedInfo.columnKey === "glAccount" ? sortedInfo.order : null,
    },
    {
      title: "Property-Unit",
      dataIndex: "propertyUnit",
      key: "propertyUnit",
    },
    {
      title: "Last Billed On",
      dataIndex: "lastBilledOn",
      key: "lastBilledOn",
      sorter: (a, b) => a.lastBilledOn.length - b.lastBilledOn.length,
      sortOrder: sortedInfo.columnKey === "lastBilledOn" ? sortedInfo.order : null,
    },
    {
      title: "Post Code",
      dataIndex: "postCode",
      key: "postCode",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      sorter: (a, b) => a.amount.length - b.amount.length,
      sortOrder: sortedInfo.columnKey === "amount" ? sortedInfo.order : null,
    },
    {
      title: "Repeats",
      dataIndex: "repeats",
      key: "repeats",
    },
  ];
  return (
    <>
      <div className="recurring-invoices">
        <PageHeading heading="Recurring Invoices" />
        <Row>
          <Col span={24}>
            <FilterContainer
              heading={
                "Filter recurring bills by using any of the search filters below."
              }
            >
              <Form
                name="basic"
                labelCol={{
                  span: 6,
                }}
                wrapperCol={{
                  span: 16,
                }}
                initialValues={{
                  remember: true,
                }}
                autoComplete="off"
                colon={false}
              >
                <Row>
                  <Col span={24}>
                    <Form.Item label="Properties">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by property, group, portfolio, or owner"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Units">
                      <MultiSelect
                        options={[]}
                        placeholder="Search by units"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Payee">
                      <Select
                        options={[]}
                        placeholder="Start typing to search"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="GL Accounts">
                      <TreeMultiSelect
                        options={[]}
                        placeholder="Select GL Account"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label="Amount">
                      <InputNumber
                        placeholder="Search by amount"
                        addonBefore={<FaDollarSign size={12} />}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    <Form.Item label=" ">
                      <Button type="primary" htmlType="submit">
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </FilterContainer>
          </Col>
        </Row>
        <Row justify="center">
        <Col className="table-container" span={24}>
            <Table
              columns={columns}
              dataSource={[]}
              onChange={handleChange}
              onRow={(record) => {
                return {
                  onClick: () =>
                    navigate(
                      `/accounting/payables_bills/recurring_invoices/${record?.id}`
                    ),
                };
              }}
            />
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PayablesRecInvoicesRightBar} />
      </div>
    </>
  );
}

export default RecurringInvoices;
